import { CognitoUser, UserState, UserData } from './user.types';

// action strings
export const LOGIN_CLEAN = 'LOGIN_CLEAN';
export const LOGIN_USER_REQUEST = 'LOGIN_USER';
export const LOGIN_USER_SUCCESSFUL = 'LOGIN_USER_SUCCESSFUL';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR';
export const LOGOUT_USER = 'LOGOUT_USER';
export const GET_USER_BY_ID = 'GET_USER_BY_ID';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_USERS_SUCCESSFUL = 'GET_ALL_USERS_SUCCESSFUL';
export const GET_ALL_USERS_ERROR = 'GET_ALL_USERS_ERROR';
export const SIGNUP_USER_SUCCESSFUL = 'SIGNUP_USER_SUCCESSFUL';
export const SIGNUP_USER_ERROR = 'SIGNUP_USER_ERROR';
export const SIGNUP_USER_REQUEST = 'SIGNUP_USER';
export const SEND_CODE_REQUEST = 'SEND_CODE_REQUEST';
export const SEND_CODE_SUCCESSFUL = 'SEND_CODE_SUCCESSFUL';
export const SEND_CODE_ERROR = 'SEND_CODE_ERROR';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESSFUL = 'RESET_PASSWORD_SUCCESSFUL';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';
export const USER_REQUEST = 'USER_REQUEST';
export const USER_RESPONSE = 'USER_RESPONSE';

export interface LoginAction {
  type: typeof LOGIN_USER_REQUEST;
  payload: CognitoUser;
}

export interface SignupAction {
  type: typeof SIGNUP_USER_REQUEST;
}

export interface LoginSuccessfulAction {
  type: typeof LOGIN_USER_SUCCESSFUL;
  payload: CognitoUser;
}

export interface SignupSuccessfulAction {
  type: typeof SIGNUP_USER_SUCCESSFUL;
  payload: string;
}

export interface LoginErrorAction {
  type: typeof LOGIN_USER_ERROR;
  error: string | undefined;
}

export interface SignupErrorAction {
  type: typeof SIGNUP_USER_ERROR;
  error: string | undefined;
}

export interface LogoutUserAction {
  type: typeof LOGOUT_USER;
  payload: null | undefined;
}

export interface loginCleanAction {
  type: typeof LOGIN_CLEAN;
  payload: UserState;
}

export interface GetUserByIdAction {
  type: typeof GET_USER_BY_ID;
  payload: CognitoUser;
}

export interface SendCodeAction {
  type: typeof SEND_CODE_REQUEST;
}

export interface SendCodeSuccessfulAction {
  type: typeof SEND_CODE_SUCCESSFUL;
  email: string;
}

export interface SendCodeErrorAction {
  type: typeof SEND_CODE_ERROR;
  error: string | undefined;
}

export interface ResetPasswordAction {
  type: typeof RESET_PASSWORD_REQUEST;
}
export interface ResetPasswordSuccessfulAction {
  type: typeof RESET_PASSWORD_SUCCESSFUL;
  email: string;
}

export interface ResetPasswordErrorAction {
  type: typeof RESET_PASSWORD_ERROR;
  error: string | undefined;
}

export interface UserRequestAction {
  type: typeof USER_REQUEST;
  payload: UserData;
}

export interface UserResponseAction {
  type: typeof USER_RESPONSE;
  payload: UserData;
}

export type UserActionTypes =
  | LoginErrorAction
  | LoginSuccessfulAction
  | LoginAction
  | loginCleanAction
  | LogoutUserAction
  | GetUserByIdAction
  | SignupAction
  | SignupSuccessfulAction
  | SignupErrorAction
  | SendCodeAction
  | SendCodeSuccessfulAction
  | SendCodeErrorAction
  | ResetPasswordAction
  | ResetPasswordSuccessfulAction
  | ResetPasswordErrorAction
  | UserRequestAction
  | UserResponseAction;

export type UserActions = UserActionTypes;
